/* unplugin-vue-components disabled */import script from "./admin.vue?vue&type=script&setup=true&lang=ts"
export * from "./admin.vue?vue&type=script&setup=true&lang=ts"

import "./admin.vue?vue&type=style&index=0&id=3466d5a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3466d5a2"]])

export default __exports__